import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';

const faqData = [
  {
    q: '黑料导航是什么？',
    a: '黑料导航是一个专业的娱乐黑料聚合平台，致力于为网友精准聚合全网最热娱乐黑料、明星丑闻、网红爆料内容。我们通过智能采集和人工筛选相结合的方式，确保内容的时效性、真实性和全面性，让用户一站式浏览最新最全的娱乐资讯。',
  },
  {
    q: '黑料导航的内容来源是哪里？',
    a: '我们的内容主要来源于各大社交平台、娱乐媒体、知名狗仔账号以及网友投稿。所有内容均标注来源，仅供娱乐参考。我们会对信息进行多方核实，但不保证所有内容100%准确，请网友理性看待。',
  },
  {
    q: '如何第一时间获取最新黑料？',
    a: '您可以将黑料导航加入浏览器收藏夹，或关注我们的社交媒体账号。我们每天会多次更新内容，确保您不错过任何热点。未来我们还将推出邮件订阅和APP推送功能，敬请期待。',
  },
  {
    q: '黑料导航是否收费？',
    a: '黑料导航目前完全免费，不向用户收取任何费用。我们的目标是打造最全面的娱乐黑料聚合平台，让所有对娱乐八卦感兴趣的用户都能方便快捷地获取信息。',
  },
  {
    q: '如何联系我们？',
    a: '您可以通过页面底部的联系方式与我们取得联系。如有内容侵权问题、合作意向或意见建议，欢迎随时联系我们，我们会在24小时内回复。',
  },
];

export default function About() {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黑料导航',
    url: 'https://heiliaodaohang.com',
    description: '最全娱乐黑料聚合平台，精准聚合全网最热娱乐黑料、明星丑闻、网红爆料内容。',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@heiliaodaohang.com',
    },
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 黑料导航',
    description: '了解黑料导航的品牌故事、平台口碑和联系方式。最全娱乐黑料聚合平台。',
    url: 'https://heiliaodaohang.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '黑料导航',
      url: 'https://heiliaodaohang.com',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  };

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="关于我们 - 黑料导航 | 品牌介绍、口碑与联系方式"
        description="了解黑料导航的品牌故事与发展历程。最全娱乐黑料聚合平台，为你精准聚合全网最热娱乐黑料、明星丑闻、网红爆料内容。查看我们的口碑评价与联系方式。"
        keywords="黑料导航,关于我们,娱乐黑料平台,品牌介绍,联系方式,黑料导航口碑"
        canonicalUrl="https://heiliaodaohang.com/about"
        ogImage="https://readdy.ai/api/search-image?query=Modern%20office%20workspace%20with%20warm%20lighting%20and%20team%20collaboration%2C%20professional%20atmosphere%2C%20clean%20minimalist%20design%2C%20red%20branding%20accents&width=1200&height=630&seq=og-about&orientation=landscape"
        schema={{ ...organizationSchema, ...webPageSchema, ...faqSchema }}
      />

      <Navbar />

      <main className="pt-20 md:pt-24 pb-10">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />

            <section className="mb-12">
              <div className="w-full aspect-[21/9] rounded-2xl overflow-hidden mb-8">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20media%20newsroom%20with%20large%20screens%20displaying%20entertainment%20news%2C%20warm%20ambient%20lighting%2C%20professional%20team%20at%20work%2C%20red%20and%20dark%20theme%2C%20editorial%20photography%20style&width=1600&height=700&seq=about-hero&orientation=landscape"
                  alt="黑料导航团队"
                  title="黑料导航 - 关于我们"
                  className="w-full h-full object-cover"
                />
              </div>

              <h1 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-4">关于黑料导航</h1>

              <div className="space-y-6 text-foreground-700 leading-relaxed">
                <p>
                  <strong>黑料导航</strong>成立于2024年，是国内领先的娱乐黑料聚合平台。我们致力于为网友提供一站式的娱乐资讯聚合服务，精准收集和整理全网最热门的明星黑料、网红爆料、娱乐八卦等内容。
                </p>
                <p>
                  在这个信息爆炸的时代，娱乐资讯分散在各个平台和渠道，用户想要全面了解最新动态往往需要浏览多个网站和应用。黑料导航的使命就是解决这一痛点 —— 我们通过先进的信息聚合技术，将全网娱乐黑料内容汇聚于一处，让用户省时高效地获取最新动态。
                </p>
                <p>
                  我们的团队由资深娱乐编辑和技术工程师组成，既有对娱乐行业的深刻理解，也有强大的技术实现能力。每一篇被收录的内容，都经过我们的多重筛选和验证，确保信息的真实性和可读性。
                </p>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-6">平台数据</h2>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {[
                  { value: '5000+', label: '收录文章', icon: 'ri-article-line' },
                  { value: '8', label: '内容分类', icon: 'ri-folder-line' },
                  { value: '100万+', label: '月活跃用户', icon: 'ri-user-line' },
                  { value: '24h', label: '内容更新频率', icon: 'ri-refresh-line' },
                ].map((stat, index) => (
                  <div
                    key={index}
                    className="bg-background-50 border border-background-200/70 rounded-xl p-5 text-center"
                  >
                    <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center bg-accent-100 rounded-lg">
                      <i className={`${stat.icon} text-lg text-accent-600`}></i>
                    </div>
                    <div className="text-xl md:text-2xl font-bold text-foreground-900 mb-1">{stat.value}</div>
                    <div className="text-xs text-foreground-500">{stat.label}</div>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-6">用户口碑</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {[
                  {
                    name: '娱乐达人小王',
                    text: '自从发现黑料导航，再也不用来回切换各个平台刷八卦了。内容更新快、分类清晰，每天必刷！',
                    rating: 5,
                  },
                  {
                    name: '吃瓜群众小李',
                    text: '界面简洁好看，文章质量也很高。关键是聚合了全网的爆料，省时省力，强烈推荐给所有吃瓜爱好者！',
                    rating: 5,
                  },
                  {
                    name: '媒体人老张',
                    text: '作为行业从业者，黑料导航是我获取行业动态的重要渠道。信息覆盖面广，时效性强，专业度值得肯定。',
                    rating: 5,
                  },
                ].map((review, index) => (
                  <div key={index} className="bg-background-50 border border-background-200/70 rounded-xl p-5">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: review.rating }).map((_, i) => (
                        <div key={i} className="w-4 h-4 flex items-center justify-center text-accent-500">
                          <i className="ri-star-fill text-sm"></i>
                        </div>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">{review.text}</p>
                    <p className="text-xs font-semibold text-foreground-900">{review.name}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-6">联系我们</h2>
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-primary-100 rounded-lg">
                      <i className="ri-mail-line text-lg text-primary-600"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                      <p className="text-sm text-foreground-600">contact@heiliaodaohang.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-accent-100 rounded-lg">
                      <i className="ri-wechat-line text-lg text-accent-600"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">微信公众号</h3>
                      <p className="text-sm text-foreground-600">搜索"黑料导航"关注我们</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-secondary-100 rounded-lg">
                      <i className="ri-weibo-line text-lg text-secondary-600"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">微博</h3>
                      <p className="text-sm text-foreground-600">@黑料导航官方微博</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-primary-100 rounded-lg">
                      <i className="ri-earth-line text-lg text-primary-600"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">官方网站</h3>
                      <p className="text-sm text-foreground-600">https://heiliaodaohang.com</p>
                    </div>
                  </div>
                </div>

                <h3 className="text-lg font-heading text-foreground-900 mb-4">发送消息</h3>
                <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <input
                      type="text"
                      name="name"
                      placeholder="你的姓名"
                      className="w-full px-4 py-3 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-900 outline-none focus:border-primary-300 transition-colors"
                    />
                    <input
                      type="email"
                      name="email"
                      placeholder="你的邮箱"
                      className="w-full px-4 py-3 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-900 outline-none focus:border-primary-300 transition-colors"
                    />
                  </div>
                  <textarea
                    name="message"
                    placeholder="请输入你的留言内容（不超过500字）"
                    maxLength={500}
                    rows={4}
                    className="w-full px-4 py-3 bg-background-100 border border-background-200 rounded-lg text-sm text-foreground-900 outline-none focus:border-primary-300 transition-colors resize-none"
                  ></textarea>
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="honeypot-field"
                  />
                  <button
                    type="submit"
                    className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full whitespace-nowrap transition-colors cursor-pointer"
                  >
                    发送消息
                  </button>
                </form>
              </div>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-6">常见问题</h2>
              <div className="space-y-4">
                {faqData.map((item, index) => (
                  <details key={index} className="bg-background-50 border border-background-200/70 rounded-xl group">
                    <summary className="px-5 py-4 text-sm font-semibold text-foreground-900 cursor-pointer flex items-center justify-between list-none">
                      {item.q}
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 ml-2">
                        <i className="ri-arrow-down-s-line text-foreground-400 group-open:hidden"></i>
                        <i className="ri-arrow-up-s-line text-foreground-400 hidden group-open:block"></i>
                      </div>
                    </summary>
                    <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                      {item.a}
                    </div>
                  </details>
                ))}
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}